import { EditScheduledPaymentPayload, UpdateSchedulePaymentV4Payload } from '@aiwyn/api';

export class GetAutoPayClients {
  static readonly type: string = '[SettingsState] GetAutoPayClients';

  constructor(public forceRefresh: boolean = false) { }
}

export class DisableAutoPayClient {
  static readonly type: string = '[SettingsState] DisableAutoPayClient';

  constructor(public autoPayId: number) { }
}

export class GetPaymentPlans {
  static readonly type: string = '[SettingsState] GetPaymentPlans';

  constructor(public forceRefresh: boolean = false) { }
}

export class GetScheduledPayments {
  static readonly type: string = '[SettingsState] GetScheduledPayments';

  constructor(public endingDate: string = '', public forceRefresh: boolean = false) { }
}

export class ClearScheduledPayments {
  static readonly type: string = '[SettingsState] ClearScheduledPayments';
}

export class DeclinePaymentV3 {
  static readonly type: string = '[SettingsState] DeclinePaymentV3';

  constructor(public id: number) { }
}

export class DeclineRecurringPaymentV4 {
  static readonly type: string = '[SettingsState] DeclineRecurringPaymentV4';

  constructor(public id: number) { }
}

export class DeclineAutoPaymentV4 {
  static readonly type: string = '[SettingsState] DeclineAutoPaymentV4';

  constructor(public id: number) { }
}

export class ResumePaymentV3 {
  static readonly type: string = '[SettingsState] ResumePaymentV3';

  constructor(public id: number) { }
}

export class ResumeRecurringPaymentV4 {
  static readonly type: string = '[SettingsState] ResumeRecurringPaymentV4';

  constructor(public id: number) { }
}

export class ResumeAutoPaymentV4 {
  static readonly type: string = '[SettingsState] ResumeAutoPaymentV4';

  constructor(public id: number) { }
}

export class UpdatePaymentV3 {
  static readonly type: string = '[SettingsState] UpdatePaymentV3';

  constructor(public editedScheduledPaymentPayload: EditScheduledPaymentPayload) { }
}

export class UpdatePaymentV4 {
  static readonly type: string = '[SettingsState] UpdatePaymentV4';

  constructor(public payload: UpdateSchedulePaymentV4Payload) { }
}

export class GetTaxPayments {
  static readonly type: string = '[SettingsState] GetTaxPayments';

  constructor(public forceRefresh: boolean = false) { }
}

export class ClearTaxPayments {
  static readonly type: string = '[SettingsState] ClearTaxPayments';
}
